import {ProductType} from "./ProductType";

export class ProductName {
    static toString(type: ProductType) {
        switch (type) {
            case ProductType.SEDESTRAL:
                return "sedestral";
            case ProductType.PANEL:
                return "panel";
            case ProductType.WEBSITE:
                return "website";
            case ProductType.BLOG:
                return "blog";
            case ProductType.COMMUNITY:
                return "community";
            case ProductType.ADMIN:
                return "admin";
        }
    }
}